import { createBrowserRouter, Navigate } from "react-router";
import { AccountPage } from "./pages/AccountPage";
import { CheckEmailPage } from "./pages/auth/CheckEmailPage";
import { InvitationPage } from "./pages/auth/InvitationPage";
import { LoginPage } from "./pages/auth/LoginPage";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/auth/PasswordPages";
import { SignupPage } from "./pages/auth/SignupPage";
import { ChamberPage } from "./pages/chamber/ChamberPage";
import { AlertsTab } from "./pages/company/AlertsTab";
import { AuditLogMonthPage, AuditLogTab } from "./pages/company/AuditLogTab";
import { CashTab } from "./pages/company/CashTab";
import { ClientDocumentsPage } from "./pages/company/ClientDocumentsPage";
import { ClientsTab } from "./pages/company/ClientsTab";
import { CompanyLayout } from "./pages/company/CompanyLayout";
import { NoticesMonthPage } from "./pages/company/NoticesMonthPage";
import { OperationsMonthPage } from "./pages/company/OperationsMonthPage";
import { OperationsTab } from "./pages/company/OperationsTab";
import { ReportsTab } from "./pages/company/ReportsTab";
import { SettingsTab } from "./pages/company/SettingsTab";
import { HomeRedirect, NotFoundPage, OnboardingPage, RequireSession, RouteErrorPage } from "./pages/SessionPages";

// URL paths are English; every visible label is Spanish.
export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/signup", element: <SignupPage /> },
  { path: "/check-email", element: <CheckEmailPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/invitation/:token", element: <InvitationPage /> },
  {
    element: <RequireSession />,
    errorElement: <RouteErrorPage />,
    children: [
      { path: "/", element: <HomeRedirect /> },
      { path: "/onboarding", element: <OnboardingPage /> },
      { path: "/account", element: <AccountPage /> },
      { path: "/chamber", element: <ChamberPage /> },
      {
        path: "/companies/:companyId",
        element: <CompanyLayout />,
        children: [
          { index: true, element: <Navigate to="clients" replace /> },
          { path: "clients", element: <ClientsTab /> },
          { path: "clients/:clientId/documents", element: <ClientDocumentsPage /> },
          // Operations, notices and the audit log: one folder per month, then that month.
          { path: "operations", element: <OperationsTab /> },
          { path: "operations/:month", element: <OperationsMonthPage /> },
          { path: "alerts", element: <AlertsTab /> },
          { path: "reports", element: <ReportsTab /> },
          { path: "reports/:month", element: <NoticesMonthPage /> },
          { path: "cash", element: <CashTab /> },
          { path: "audit-log", element: <AuditLogTab /> },
          { path: "audit-log/:month", element: <AuditLogMonthPage /> },
          { path: "settings", element: <SettingsTab /> },
        ],
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
